import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const GlobalSelect = ({
  loadOptions,   // função async(inputValue, page) => { options: [], hasMore: boolean }
  onChange,
  onOpen,
  placeholder = 'Selecione...',
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchOptions = async (search = '', nextPage = 1, reset = false) => {
    if (!hasMore && !reset) return;

    setLoading(true);
    try {
      const response = await loadOptions(search, nextPage);
      setOptions(prevOptions => reset ? response.options : [...prevOptions, ...response.options]);
      setHasMore(response.hasMore);
      setPage(nextPage + 1); // próxima página
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Carrega a primeira página ao montar
    fetchOptions(inputValue, 1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    setPage(1);
    setHasMore(true);
    fetchOptions(newValue, 1, true); // pesquisa reinicia página
    return newValue;
  };

  const handleMenuOpen = () => {
    if (onOpen) onOpen();
  };

  // Quando rolar no menu e chegar ao final, carrega mais
  const handleMenuScrollToBottom = () => {
    if (hasMore && !loading) {
      fetchOptions(inputValue, page);
    }
  };

  return (
    <Select
      options={options}
      onChange={onChange}
      onInputChange={handleInputChange}
      onMenuOpen={handleMenuOpen}
      onMenuScrollToBottom={handleMenuScrollToBottom}
      placeholder={placeholder}
      isLoading={loading}
      {...props}
    />
  );
};

GlobalSelect.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  placeholder: PropTypes.string,
};

export default GlobalSelect;
